import type { Writable } from 'svelte/store';

export interface NetworkInformationStore extends Writable<NetworkInformation> {
    get():NetworkInformation;
    isSupported(): boolean;
    setInternetMetrics(networkMetrics: NetworkInformation): void;
}

export enum EffectiveInternetType {
    FourG = '4g',
    ThreeG = '3g',
    TwoG = '2g',
    SlowTwoG = 'slow-2g',
    Unknown = 'unknown,'
}

export enum InternetType {
    Bluetooth = 'bluetooth',
    Cellular = 'cellular',
    Ethernet = 'ethernet',
    None = 'none',
    WiFi = 'wifi',
    WiMax = 'wimax',
    Other = 'other',
    Unknown = 'unknown',
}

export type NetworkInformation = {
    downlink: number;
    effectiveType: EffectiveInternetType;
    rtt: number;
    isOnline: boolean;
    type: InternetType;
}

export enum InternetQuality {
    Good = 'good',
    SmallBandwith = 'small_bandwidth',
    SlowNetwork = 'slow_network',
    VerySlowNetwork = 'very_slow_network',
    Offline = 'offline',
    NotSupported = 'not_supported'
}

export type NetworkQualityStoreState = {
    quality: InternetQuality;
}